var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorandappointmentslot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-stethoscope_3_",
    "data-name": "icons8-stethoscope (3)",
    className: "cls-1",
    d: "M3.4,2A1.4,1.4,0,0,0,2,3.4V5.5a4.9,4.9,0,0,0,3.086,4.54,2.091,2.091,0,0,0,1.114.931V13.2A2.8,2.8,0,0,0,9,16h2.8a2.8,2.8,0,0,0,2.8-2.8v-.129a2.1,2.1,0,1,0-1.4,0V13.2a1.4,1.4,0,0,1-1.4,1.4H9a1.4,1.4,0,0,1-1.4-1.4V10.971a2.091,2.091,0,0,0,1.114-.931A4.906,4.906,0,0,0,11.8,5.484V3.4A1.4,1.4,0,0,0,10.4,2H9V3.4h1.4V5.5a3.5,3.5,0,1,1-7-.016V3.4H4.8V2Zm10.5,8.225a.875.875,0,1,1-.875.875A.875.875,0,0,1,13.9,10.225Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorandappointmentslot);
export default __webpack_public_path__ + "static/media/doctorandappointmentslot.3b594036563cd206aee8652f31ebec5a.svg";
export { ForwardRef as ReactComponent };